import { useEffect, useState } from 'react'

import { DSButton, DSCircularLoading, DSModal, DSText } from '@vr/ds-react'

import { MessageCopy } from './styled'
import ModalError from '@/components/modal-error'
import { useOperatorGet } from '@/hooks/use-operators-get'

const ModalOperatorAccess = ({
  unitId,
  operatorId,
  operadora,
  onClose = () => {}
}: {
  unitId: string
  operatorId: string
  operadora?: string
  onClose?: () => void
}) => {
  const { operatorGet, isLoading } = useOperatorGet()
  const [result, setResult] = useState<any>(null)
  const [showTag, setShowTag] = useState<any>(null)
  const [modalError, setModalError] = useState(false)

  const userString = localStorage.getItem('user')
  const user = userString ? JSON.parse(userString) : {}

  const description = 'Acesso à operadora'
  const creationDate = new Date().toISOString()
  const userId = user?.userId
  const userName = user?.userName

  useEffect(() => {
    const fetchData = async () => {
      const response = await operatorGet(
        description,
        creationDate,
        userId,
        userName,
        unitId,
        operatorId
      )

      if (response.sucesso) {
        setResult(response.conteudo)
      } else {
        setModalError(true)
      }
    }
    fetchData()
  }, [unitId, operatorId])

  const handleTagDisplay = (type: 'login' | 'senha') => {
    setShowTag(type)
    setTimeout(() => {
      setShowTag(false)
    }, 2000)
  }

  return (
    <>
      <DSModal config={{ show: true, onClose }}>
        <DSModal.Header onClose={onClose}>
          Dados de acesso à operadora
        </DSModal.Header>
        {isLoading ? (
          <DSModal.Body>
            <DSCircularLoading isLoading shouldBlur={false} />
          </DSModal.Body>
        ) : (
          <DSModal.Body
            css={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-start',
              gap: '1rem'
            }}
          >
            <DSText weight='bold'>{operadora}</DSText>
            <DSButton
              iconLeft='principal-external-link'
              variant='ghost'
              size='small'
              outlined
              onClick={() => {
                window.open(result?.url, '_blank')
              }}
            >
              Portal da operadora
            </DSButton>
            <DSText
              weight='bold'
              size='sm'
              style={{ display: 'flex', alignItems: 'center' }}
            >
              Login:{' '}
              <DSButton
                iconRight='principal-copy'
                variant='ghost'
                size='small'
                onClick={() => {
                  navigator.clipboard.writeText(result?.userOperator)
                  handleTagDisplay('login')
                }}
              >
                {result?.userOperator}
              </DSButton>
              <MessageCopy
                variant='success-light'
                className={showTag === 'login' ? 'show' : 'hide'}
              >
                Copiado
              </MessageCopy>
            </DSText>
            <DSText
              weight='bold'
              size='sm'
              style={{ display: 'flex', alignItems: 'center' }}
            >
              Senha:{' '}
              <DSButton
                iconRight='principal-copy'
                variant='ghost'
                size='small'
                onClick={() => {
                  navigator.clipboard.writeText(result?.passwordOperator)
                  handleTagDisplay('senha')
                }}
              >
                {result?.passwordOperator}
              </DSButton>
              <MessageCopy
                variant='success-light'
                className={showTag === 'senha' ? 'show' : 'hide'}
              >
                Copiado
              </MessageCopy>
            </DSText>
          </DSModal.Body>
        )}
        <DSModal.Footer css={{ display: 'flex', justifyContent: 'center' }}>
          <DSButton onClick={onClose} variant='secondary'>
            Fechar
          </DSButton>
        </DSModal.Footer>
      </DSModal>

      <ModalError
        isOpen={modalError}
        title='Erro ao buscar dados de acesso'
        onClose={onClose}
      >
        <DSText>
          Ocorreu um erro ao buscar os dados de acesso à operadora. Por favor,
          tente novamente mais tarde.
        </DSText>
      </ModalError>
    </>
  )
}

export default ModalOperatorAccess
